import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getClientShell } from '../../constants/clientShell';
import { isAdminSession } from '../../constants/adminSession';
import { authService } from '../../services/authService';
import { useAuthStore } from '../../stores/authStore';

/**
 * 已登录且为 PC 模式时，访问移动端首页 `/` 自动进入远程控制台。
 */
export const ClientShellGuard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const storeAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (isAdminSession()) return;
    const isAuthenticated = storeAuthenticated || authService.isAuthenticated();
    if (!isAuthenticated) return;
    if (location.pathname !== '/') return;
    if (getClientShell() !== 'pc') return;
    navigate('/radio-remote', { replace: true });
  }, [storeAuthenticated, location.pathname, navigate]);

  return null;
};
